<div class="omgui-feature-card card border-0 pt-sm-4">
  <ng-content select="omgui-feature-card-content"></ng-content>
</div>
